(() => {
  // The block can appear more than once, including dynamically loaded products.
  if (window.productQuantityDiscountsInitialized) return;
  window.productQuantityDiscountsInitialized = true;

  const blockSelector = '.product__controls-group-quantity';
  const inputSelector = '[data-quantity-input]';
  const validQuantity = value => Number.isSafeInteger(Number(value)) && Number(value) >= 1;

  function sync(block) {
    const input = block.querySelector(inputSelector);
    if (!input) return;
    const quantity = Number(input.value);
    const buttons = [...block.querySelectorAll('.quantity-discount-btn')];
    buttons.forEach(button => {
      const selected = quantity === Number(button.dataset.quantityCustom);
      button.classList.toggle('active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });

    const lastButton = buttons.reduce((highest, button) =>
      !highest || Number(button.dataset.quantityCustom) > Number(highest.dataset.quantityCustom)
        ? button : highest, null);
    const accordion = block.querySelector('.custom-quantity-accordion');
    if (!accordion || !lastButton || buttons.length < 2) return;
    const minimum = Number(lastButton.dataset.quantityCustom);
    const visible = quantity >= minimum;
    accordion.style.display = visible ? 'block' : 'none';
    if (!visible) {
      accordion.querySelector('.accordion-toggle').setAttribute('aria-expanded', 'false');
      return;
    }
    const customInput = accordion.querySelector('.custom-qty-input');
    customInput.min = minimum;
    customInput.value = quantity;
    const price = Number(lastButton.dataset.priceCustom) / 100;
    const money = value => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    accordion.querySelector('.total-price').textContent = money(quantity * price);
    accordion.querySelector('.custom-qty-unit-price').textContent = `${money(price)} /unid.`;
  }

  function setQuantity(block, quantity) {
    const input = block.querySelector(inputSelector);
    if (!input || !validQuantity(quantity)) return;
    input.value = quantity;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  document.addEventListener('click', event => {
    const block = event.target.closest(blockSelector);
    if (!block) return;
    const discount = event.target.closest('.quantity-discount-btn');
    if (discount) {
      setQuantity(block, Number(discount.dataset.quantityCustom));
      return;
    }
    const toggle = event.target.closest('.accordion-toggle');
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
      return;
    }
    const control = event.target.closest('.qty-btn');
    if (!control) return;
    const customInput = block.querySelector('.custom-qty-input');
    const minimum = Number(customInput.min);
    const current = Number(customInput.value) || minimum;
    setQuantity(block, Math.max(minimum, current + (control.classList.contains('qty-btn-plus') ? 1 : -1)));
  });

  // Capture also receives the theme's non-bubbling change events from + / -.
  document.addEventListener('change', event => {
    const block = event.target.closest(blockSelector);
    if (!block) return;
    if (event.target.matches(inputSelector)) {
      if (!validQuantity(event.target.value)) event.target.value = 1;
      sync(block);
    } else if (event.target.matches('.custom-qty-input')) {
      const minimum = Number(event.target.min);
      const quantity = validQuantity(event.target.value) ? Number(event.target.value) : minimum;
      setQuantity(block, Math.max(minimum, quantity));
    }
  }, true);

  document.addEventListener('input', event => {
    const block = event.target.closest(blockSelector);
    if (!block || !event.target.matches(inputSelector)) return;
    sync(block);
    if (validQuantity(event.target.value)) {
      // Keep the theme's hidden quantity field used by add-to-cart up to date.
      event.target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.querySelectorAll(blockSelector).forEach(sync);
})();
